import { api } from '../configs/axiosConfigs';

export const getSharedListSortEmails = async () => {
  return await api.get('/list-sorts/shared-emails');
};
